import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Box,
  InputAdornment,
  IconButton,
  TextareaAutosize,
} from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AddIcon from "@mui/icons-material/Add";
import styles from "./Qualificazione.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import styled from "@emotion/styled";
import { validationSchema3 } from "../../validation/ValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";

// Dynamic Card Component with Add Button
const DynamicCard = ({ title, initialFields, onAddField }) => {
  const [fields, setFields] = useState(
    initialFields.map((field) => ({ ...field, isNew: false }))
  );

  const handleAddField = () => {
    // Add a new empty field with a default label and mark as new
    const newField = {
      label: `Campo Aggiuntivo ${fields.length + 1}`,
      isNew: true,
    };
    setFields([...fields, newField]);

    // Optional: Call the parent component's method if needed
    if (onAddField) {
      onAddField(newField);
    }
  };

  const handleDeleteField = (index) => {
    // Remove the field at the specified index
    setFields(fields.filter((_, i) => i !== index));
  };
  const Textarea = styled(TextareaAutosize)`
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 12px;
    border-radius: 5px;
    color: #160A2A;
    background: #fff;
    border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleChange = (event) => {
        setInputValue(event.target.value);
        onChange(event);
    };

    return (
        <Textarea
            aria-label="empty textarea"
            placeholder={placeholder}
            minRows={4}
            value={inputValue}
            onChange={handleChange}
        />
    );
};
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema3),
  });
  return (
    <div className="ContattiCards">
      <Card className="card">
        <CardHeader
          className="card__header"
          title={title}
          titleTypographyProps={{ variant: "h6" }}
        />
        <CardContent className="card__body">
          <Grid container spacing={2}>
            {fields.map((field, index) => (
              <Grid
                size={12}
                key={index}
                style={{ display: "flex", alignItems: "center" }}
              >
                {fields[0].label === "Note" ? (
                  <Controller
                    name="notes"
                    control={control}
                    render={({ field }) => (
                      // <Textarea aria-label="empty textarea" placeholder="Empty" />
                      <EmptyTextarea placeholder="Note" />
                      // <TextareaAutosize
                      //   maxRows={4}
                      //   aria-label="maximum height"
                      //   className="CustomInputBox CustomTextArea"
                      //   // {...field}
                      //   label="Note"
                      //   multiline
                      //   variant="outlined"
                      // />
                    )}
                  />
                ) : (
                  <TextField
                    className={styles["text-field"]}
                    fullWidth
                    label={field.label}
                    type={field.type || "text"}
                    variant="outlined"
                  />
                )}
                {field.isNew && (
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDeleteField(index)}
                    style={{ marginLeft: "8px" }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
      <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
        {fields[0].label === "Note" ? (
          ""
        ) : (
          <Button
            className="Aggiungi_btn"
            startIcon={<AddIcon />}
            onClick={handleAddField}
          >
            Aggiungi
          </Button>
        )}
      </Box>
    </div>
  );
};

const HrQualificazione = () => {
  const path = window.location.pathname;
  const [cardData, setCardData] = useState([]);

  const hrCards = [
    {
      title: "Hard skill",
      fields: [
        { label: "Sviluppatore senior" },
        { label: "Linguaggi conosciuti" },
        { label: "Anni di esperienza" },
      ],
    },
    {
      title: "Soft skill",
      fields: [
        { label: "Front end" },
        { label: "Spiccate capacita relazionali" },
      ],
    },
    {
      title: "Note",
      fields: [{ label: "Note" }],
    },
  ];

  const hrCandidatoCards = [
    {
      title: "Skill",
      fields: [
        { label: "Settore" },
        { label: "Categoria categoria azienda" },
        { label: "Codice adeco" },
      ],
    },
    {
      title: "Attivita",
      fields: [
        { label: "Progettazione e edirezione lavori" },
        { label: "Prove geioteniche" },
        { label: "Rilievi topografici" },
        { label: "Pratiche catastali" },
      ],
    },
    {
      title: "Attivita",
      fields: [
        { label: "Progettazione e direzione lavori" },
        { label: "Prove ubanistica" },
        { label: "Progettazione strutturale" },
        { label: "Progettazione architettonica" },
      ],
    },
  ];

  useEffect(() => {
    if (path === "/hr/sub-colaboratory/Qualificazione") {
      setCardData(hrCards);
    } else if (path === "/hr/candidati/candidato/Qualificazione") {
      setCardData(hrCandidatoCards);
    } else if (path === "/angrafiche/candidati/Qualificazione") {
      setCardData(hrCandidatoCards);
    } else if (path === "/angrafiche/sub-colaboratory/Qualificazione") {
      setCardData(hrCards);
    } else {
      <></>;
    }
  }, [path]);

  return (
    <Box className="customTabBlock" maxWidth="xl">
      <Box className="customTabBlock__body">
        <Grid container spacing={2.5}>
          {cardData.map((card, index) => (
            <Grid size={{xs:12, md:4}} key={index}>
              <DynamicCard title={card.title} initialFields={card.fields} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default HrQualificazione;
